import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import cx from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';
import cs from './index.module.scss';
import { Image } from 'antd';
import logoDark from '@/assets/logo/logo@2x.png';
import logoWhite from '@/assets/logo/logo-horizontal-white.png';
import { isFromMobile } from '@/utils/location';

const Header: React.FC = () => {
  const { push } = useHistory();
  const location = useLocation();
  const isVipPage = /^\/vip/.test(location.pathname);
  const [vipScrolled, setVipScrolled] = useState(false);

  useEffect(() => {
    if (!isVipPage) {
      setVipScrolled(false);
      return;
    }

    const handleScroll = () => {
      setVipScrolled(window.scrollY > 24);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isVipPage]);

  // VIP 首屏深色背景用左右横版白字 Logo；滚动后浅底切回深色横版 Logo
  const logoSrc = isVipPage && !vipScrolled ? logoWhite : logoDark;

  return (
    <a
      onClick={() => {
        if (!isFromMobile()) {
          push('/');
        } else {
          push('/home');
        }
      }}
      className={cx(cs.logoWrap)}
    >
      <Image width={100} src={logoSrc} preview={false} />
    </a>
  );
};

export default observer(Header);
